"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Messager = void 0;
const MQTT = require("mqtt");
const MQTTEmitter = require("mqtt-emitter");
const const_1 = require("./const");
const uuid_1 = require("uuid");
const console_logger_1 = require("@accumine/console-logger");
const options_1 = require("./options");
const defaults = Object.freeze({
    url: '',
    credentials: {
        username: '',
        password: '',
    },
    protocol: 5,
    keepAlive: 30 * 1000,
    connectionTimeout: 30 * 1000,
});
class Messager {
    constructor(options) {
        const settings = Object.assign({}, defaults, options);
        this._url = settings.url;
        this._credentials = settings.credentials;
        this._protocol = settings.protocol;
        this._keepAlive = settings.keepAlive;
        this._connectionTimeout = settings.connectionTimeout;
        this._router = new MQTTEmitter();
        this._client = null;
        this._will = settings.will;
        this._isConnected = false;
        this._router.onadd = (topic) => {
            if (!this._client) {
                throw new Error('Client is not connected, call "await messager.connect()"');
            }
            else {
                this._client.subscribe(topic);
            }
        };
        this._router.onremove = (topic) => {
            if (!this._client) {
                throw new Error('Client is not connected, call "await messager.connect()"');
            }
            else {
                this._client.unsubscribe(topic);
            }
        };
    }
    get connected() {
        return this._isConnected;
    }
    get router() {
        return this._router;
    }
    get client() {
        return this._client;
    }
    publish(topic, message, options) {
        return new Promise((resolve, reject) => {
            if (!this._client) {
                reject(new Error('Client is not connected, call "await messager.connect()"'));
            }
            else {
                this._client.publish(topic, JSON.stringify(message), options, (error, packet) => {
                    error ? reject(error) : resolve(packet);
                });
            }
        });
    }
    publishStatus(topic, message) {
        return new Promise((resolve, reject) => {
            if (!this._client) {
                reject(new Error('Client is not connected, call "await messager.connect()"'));
            }
            else {
                this._client.publish(topic + '/status', JSON.stringify(message), options_1.__MQTT_STATUS_PUBLISH_OPTS__, (error, packet) => {
                    error ? reject(error) : resolve(packet);
                });
            }
        });
    }
    publishExpiringStatus(topic, message) {
        return new Promise((resolve, reject) => {
            if (!this._client) {
                reject(new Error('Client is not connected, call "await messager.connect()"'));
            }
            else {
                this._client.publish(topic + '/status', JSON.stringify(message), options_1.__MQTT_STATUS_EXPIRE_PUBLISH_OPTS__, (error, packet) => {
                    error ? reject(error) : resolve(packet);
                });
            }
        });
    }
    publishState(topic, message) {
        return new Promise((resolve, reject) => {
            if (!this._client) {
                reject(new Error('Client is not connected, call "await messager.connect()"'));
            }
            else {
                this._client.publish(topic + '/state', JSON.stringify(message), options_1.__MQTT_STATE_PUBLISH_OPTS__, (error, packet) => {
                    error ? reject(error) : resolve(packet);
                });
            }
        });
    }
    publishAction(topic, message, timeout = 5000) {
        let _message = {
            id: uuid_1.v4(),
            data: message.data,
        };
        return new Promise((resolve, reject) => {
            if (!this._client) {
                reject(new Error('Client is not connected, call "await messager.connect()"'));
            }
            else {
                this._client.publish(topic, JSON.stringify(_message), (error, _) => {
                    error ? reject(error) : null;
                    let response = (status) => {
                        clearTimeout(timer);
                        resolve(status);
                    };
                    this._router.once(topic + '/action/' + _message.id, response);
                    let timer = setTimeout(() => {
                        this._router.removeListener(topic + '/action/' + _message.id, response);
                        reject({
                            status: 'Failed',
                            message: 'Timed out waiting for response',
                        });
                    }, timeout);
                });
            }
        });
    }
    on(topic, callback) {
        this._router.on(topic, callback);
    }
    onAction(topic, callback) {
        this._router.on(topic, (message) => {
            try {
                callback(message.data);
                this._client.publish(topic + '/action/' + message.id, JSON.stringify({
                    status: const_1.ACTION.SUCCESS,
                }), options_1.__MQTT_ACTION_PUBLISH_OPTS__);
            }
            catch (error) {
                this._client.publish(topic + '/action/' + message.id, JSON.stringify({
                    status: const_1.ACTION.FAIL,
                    message: error.message,
                    stack: error.stack,
                }), options_1.__MQTT_ACTION_PUBLISH_OPTS__);
            }
        });
    }
    removeListeners(topic, listener) {
        this._router.removeListener(topic, listener);
    }
    removeAllListeners(topic) {
        this._router.removeAllListeners(topic);
    }
    connect() {
        this._client = MQTT.connect(this._url, {
            username: this._credentials.username,
            password: this._credentials.password,
            protocolVersion: this._protocol,
            keepalive: this._keepAlive,
            will: this._will,
        });
        let connected = new Promise((resolve, reject) => {
            let timer = setTimeout(() => {
                this._client.end();
                reject(new Error('Timeout connecting to MQTT broker'));
            }, this._connectionTimeout);
            this._client.once('connect', () => {
                clearTimeout(timer);
                resolve(this._client);
            });
        });
        this._client.on('connect', () => {
            console_logger_1.log.info('MQTT: Broker connected');
            this._isConnected = true;
        });
        this._client.on('reconnect', () => {
            console_logger_1.log.info('MQTT: Broker attempting to reconnect');
            this._isConnected = false;
        });
        this._client.on('disconnect', () => {
            console_logger_1.log.info('MQTT: Broker disconnected');
            this._isConnected = false;
        });
        this._client.on('error', (error) => {
            console_logger_1.log.error(error);
        });
        this._client.on('message', (topic, data) => {
            this._router.emit(topic, JSON.parse(data.toString()));
        });
        return connected;
    }
    close() {
        return new Promise((resolve, reject) => {
            this._client.end(false, {}, (error) => error ? reject(error) : resolve());
        });
    }
}
exports.Messager = Messager;
//# sourceMappingURL=messager.js.map